import * as React from 'react';
import { AlertAction } from '@ixicare/resources';
import { Ban, Bell, Check, CheckCheck, LucideIcon, Users, X } from 'lucide-react';
import styles from './AlertEventIcon.module.css';

export type AlertEventKind = 'triggered' | 'accepted' | 'rejected' | 'resolved' | 'cancelled' | 'escalated';

const EVENT_ICONS: Record<AlertEventKind, LucideIcon> = {
  triggered: Bell,
  accepted: Check,
  rejected: X,
  resolved: CheckCheck,
  cancelled: Ban,
  escalated: Users,
};

/** Triggered takes the alarm's priority colour, so it has none of its own. */
export type AlertActionEventKind = Exclude<AlertEventKind, 'triggered'>;

export const ALERT_EVENT_COLORS: Record<AlertActionEventKind, string> = {
  accepted: '#4286f3',
  rejected: '#ff2e2e',
  resolved: '#16b5b2',
  cancelled: '#9694ad',
  escalated: '#56547c',
};

export function alertActionEventKind(action: AlertAction): AlertActionEventKind {
  switch (action) {
    case AlertAction.Accept:
      return 'accepted';
    case AlertAction.Reject:
      return 'rejected';
    case AlertAction.Resolve:
      return 'resolved';
    case AlertAction.Cancel:
      return 'cancelled';
    default:
      return 'escalated';
  }
}

export function AlertEventGlyph({ kind }: { kind: AlertEventKind }) {
  const Icon = EVENT_ICONS[kind];
  return <Icon size={11} strokeWidth={3} />;
}

const DETAIL_COLOR = '#b6b6c7';

/** Without a kind it marks a detail line that belongs to an event, rather than an event of its own. */
const AlertEventIcon: React.FC<{ kind?: AlertEventKind; color?: string }> = ({ kind, color }) => (
  <span className={styles.AlertEventIcon} style={{ backgroundColor: color ?? DETAIL_COLOR }}>
    {kind ? <AlertEventGlyph kind={kind} /> : <span className={styles.Dot} />}
  </span>
);

export default AlertEventIcon;
